export default __webpack_public_path__ + "static/media/sasakawalogo.472b9c5a.png";